export const TRANSLATIONS = {
    EN: {
        SIDEBAR_MENU: {
            OVERVIEW: 'Overview',
            COMPANY_DETAILS: 'Company details',
            SHAREHOLDERS: 'Shareholders',
            DIRECTORS: 'Directors',
            EVENTS: 'Events',
            BOOKKEEPING: 'Bookkeeping',
            CONTRACT: 'Contracts',
            DOCUMENTS: 'Documents',
            TBD: 'TBD',
            PASSPORT: 'Company passport',
            JOBS: 'Jobs',
            PERMISSIONS: 'Permissions',
        },
    },
    NL: {
        SIDEBAR_MENU: {
            OVERVIEW: 'Overzicht',
            COMPANY_DETAILS: 'Bedrijfsgegevens',
            SHAREHOLDERS: 'Aandeelhouders',
            DIRECTORS: 'Bestuurders',
            EVENTS: 'Gebeurtenissen',
            BOOKKEEPING: 'Boekhouding',
            CONTRACT: 'Contracten',
            DOCUMENTS: 'Documenten',
            TBD: 'TBD',
            PASSPORT: 'Bedrijfspaspoort',
            JOBS: 'Jobs',
            PERMISSIONS: 'Rechten',
        },
    },
};
